import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth-scroll provider (Lenis). Mount once in App root.
 * Automatically pauses on prefers-reduced-motion, and disables on admin routes
 * where absolute-scroll containers otherwise fight the smoother.
 */
export default function LenisProvider({ children }) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // Disable on /admin so the sidebar layout scroll containers behave natively.
    const onAdmin = () => window.location.pathname.startsWith("/admin");
    if (reduce || onAdmin()) return;

    const lenis = new Lenis({
      duration: 1.15,
      smoothWheel: true,
      smoothTouch: false,
      easing: (t) => 1 - Math.pow(1 - t, 3),
    });

    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return children;
}
